export default __webpack_public_path__ + "static/media/dronedeploy.e4bc0864.jpg";